import {
    ControlCalidadPermisos,
    ControlCalidadPerms,
    ControlCalidadRoutes,
    PermisosProceso,
} from '@core/utils/enums/controlCalidad'

export default [
    {
        title: 'Operaciones',
        fontIcon: 'check-to-slot',
        resource: 'Control Calidad',
        action: 'ver-control-calidad',
        children: [
            {
                title: 'Mantenimiento',
                fontIcon: 'file-prescription',
                resource: 'Control Calidad',
                action: PermisosProceso.MANTENIMIENTO.VISUALIZAR,
                children: [
                    {
                        route: PermisosProceso.MANTENIMIENTO.VISUALIZAR,
                        title: 'Registro Revisión',
                        icon: 'adjust',
                        resource: 'Control Calidad',
                        action: PermisosProceso.MANTENIMIENTO.VISUALIZAR,
                    },
                ],
            },
            {
                title: 'Configuracion',
                icon: 'SettingsIcon',
                resource: 'Control Calidad',
                action: 'ver-control-calidad-configuracion',
                children: [
                    {
                        route: 'control-calidad-configurar-correos',
                        title: 'Correos ',
                        icon: 'MailIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CONFIGURACION.DIFUSION_CORREOS.VISUALIZAR,
                    },
                    {
                        route: ControlCalidadRoutes.CONFIGURAR_FIRMA_CONTRASENA,
                        title: 'Cambio de Contraseña Firmas',
                        icon: 'SettingsIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CONFIGURACION.FIRMAS.CAMBIAR_PASSWORD,
                    },
                    {
                        route: ControlCalidadRoutes.CONFIGURAR_FIRMAS_USUARIOS,
                        title: 'Usuarios',
                        icon: 'UserIcon',
                        resource: 'Control Calidad',
                        action: PermisosProceso.CONFIGURACION.USUARIOS.VISUALIZAR,
                    },
                    {
                        route: ControlCalidadRoutes.CONFIGURAR_PODERES, //TODO: Cambiar a la ruta correcta
                        title: 'Poderes de Usuario',
                        icon: 'KeyIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CONFIGURACION.PODERES.VISUALIZAR,
                    },
                    {
                        route: 'control-calidad-configuracion-permisos',
                        title: 'Ver Permisos',
                        icon: 'SettingsIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CONFIGURACION.PERMISOS.VISUALIZAR,
                    },
                    {
                        route: ControlCalidadRoutes.CONFIGURAR_PROCESOS,
                        title: 'Listas',
                        icon: 'SettingsIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CONFIGURACION.PROCESOS.VISUALIZAR,
                    },
                ],
            },
            {
                title: 'Transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Control Calidad',
                action: 'ver-control-calidad-transacciones',
                children: [
                    {
                        title: 'General',
                        route: ControlCalidadRoutes.GENERAL_TRANSACCION,
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CALIDAD.TRANSACCIONES_GENERAL.VISUALIZAR,
                    },
                    {
                        title: 'Procesos',
                        route: ControlCalidadRoutes.TRANSACCION_PROCESOS,
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CALIDAD.TRANSACCIONES_GENERAL.VISUALIZAR,
                    },
                    {
                        title: 'Gestión de Asignaciones',
                        route: ControlCalidadRoutes.PANEL_CONTROL_RESPONSABLE,
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPerms.VER_TRANSACCION_PANEL_CONTROL_RESPONSABLE,
                    },
                    {
                        title: 'Monitoreo de Asignaciones',
                        route: ControlCalidadRoutes.BANDEJA_CONTROL_ASIGNACIONES,
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPerms.VER_TRANSACCION_BANDEJA_CONTROL_ASIGNACIONES,
                    },
                    {
                        title: 'Panel de Asignación',
                        route: ControlCalidadRoutes.ASIGNACION_RESPONSABLE,
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPerms.VER_TRANSACCION_ASIGNACION_RESPONSABLE,
                    },
                    {
                        route: 'control-calidad-transaccion-bandeja-embarque',
                        title: 'Bandeja de Embarques',
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: 'ver-control-calidad-transaccion-bandeja-embarque',
                    },
                    {
                        route: 'control-calidad-transaccion-asignacion-lote',
                        title: 'Asignación de Lotes',
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: 'ver-control-calidad-transaccion-asignacion-lote',
                    },
                ],
            },
            {
                title: 'Informes',
                fontIcon: 'file-prescription',
                resource: 'Control Calidad',
                action: 'ver-control-calidad-informes',
                children: [
                    {
                        route: ControlCalidadRoutes.GENERAL,
                        title: 'General',
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CALIDAD.INFORMES_GENERAL.VISUALIZAR,
                    },
                    {
                        route: ControlCalidadRoutes.INFORMES_PROCESOS,
                        title: 'Procesos',
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CALIDAD.INFORMES_GENERAL.VISUALIZAR,
                    },
                    {
                        route: ControlCalidadRoutes.TRAZABILIDAD_INFORME,
                        title: 'Trazabilidad',
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CALIDAD.TRAZABILIDAD.VISUALIZAR,
                    },
                    {
                        route: ControlCalidadRoutes.ACCIONES_CORRECTIVAS_INFORMES,
                        title: 'Acciones Correctivas',
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CALIDAD.ACCIONES_CORRECTIVAS.INFORMES.VISUALIZAR,
                    },
                    {
                        route: ControlCalidadRoutes.ACCIONES_CORRECTIVAS_AREAS_ASIGNADAS_INFORMES,
                        title: 'Acciones Correctivas Por Asignar',
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CALIDAD.ACCIONES_CORRECTIVAS_AREAS_ASIGNADAS.INFORMES.VISUALIZAR,
                    },
                    {
                        route: ControlCalidadRoutes.ACCIONES_CORRECTIVAS_USUARIOS_ASIGNADOS_INFORMES,
                        title: 'Acciones Correctivas Asignadas',
                        icon: 'ClipboardIcon',
                        resource: 'Control Calidad',
                        action: ControlCalidadPermisos.CALIDAD.ACCIONES_CORRECTIVAS_USUARIOS_ASIGNADOS.INFORMES
                            .VISUALIZAR,
                    },
                ],
            },
        ],
    },
    {
        title: 'Verificacion',
        fontIcon: 'box',
        resource: 'Control Calidad',
        action: 'ver-control-calidad-documental',
        children: [
            {
                title: 'Transacciones',
                route: ControlCalidadRoutes.DOCUMENTAL_TRANSACCIONES_GENERAL,
                icon: 'ClipboardIcon',
                resource: 'Control Calidad',
                action: ControlCalidadPermisos.CALIDAD.TRANSACCIONES_GENERAL.VISUALIZAR,
            },
            {
                route: ControlCalidadRoutes.DOCUMENTAL_INFORMES_GENERAL,
                title: 'Informes',
                icon: 'ClipboardIcon',
                resource: 'Control Calidad',
                action: ControlCalidadPermisos.CALIDAD.INFORMES_GENERAL.VISUALIZAR,
            },
        ],
    },
    {
        title: 'Calidad',
        fontIcon: 'check',
        resource: 'Control Calidad',
        action: 'ver-control-calidad-documental-final',
        children: [
            {
                route: ControlCalidadRoutes.DOCUMENTAL_INFORMES_GENERAL_FINAL,
                title: 'Consulta de Informes',
                icon: 'ClipboardIcon',
                resource: 'Control Calidad',
                action: 'ver-control-calidad-documental-final',
            },
        ],
    },
]
